import intl from "react-intl-universal";
import Modal from '../components/Common/Modal';
import common from './common';
import { categoryMap} from './category';
import { Commun, toast } from "../utils/axios";
import eventBus from '../utils/event-bus';
import history from '../router/history';
import { changeAddressModalVisible, saveProcessExchangeCurItem } from '../store/action/exchange';
import store from '../store';
import { onDress } from '../components/Exchange/Mine/Module';
import { isAddressSdkUser, openAddressSdk } from './addressSdk';


class Exchange {
    #isExchanging = false; // 是否正在兑换
    #confirmAddressModal = null; // 确认地址弹窗
    #isMailFlag = false; // 是否确认邮寄
    constructor() {
        eventBus.addEventListener('closeConfirmAddressModal', this._closeConfirmAddressModal);
    }

    // 生成订单
    createOrder() {
        return new Promise((resolve, reject) => {
            Commun.get(`${common.starApiPrefix}/order/orderNo`).then(res => {
                return resolve(res);
            }).catch(error => {
                return reject(error);
            });
        });
    };

    /**
     * 获取商品信息
     * @param ids {Array} 需要获取商品信息的id列表
     */
    getProductInfo(ids = []) {
        return new Promise((resolve, reject) => {
            Commun.get(`${common.starApiPrefix}/items`, {
                itemIds: ids.join(',')
            }).then(res => {
                return resolve(res);
            }).catch(error => {
                return reject(error);
            });
        })
    }

    /**
     * 兑换商品
     * @param productInfo {Object} 商品信息
     * @param productInfo.itemId {Number} 商品Id
     * @param productInfo.starValue {Number} 商品价值多少颗星星
     * @param productInfo.orderNo {String} 订单号
     */
    exchangeProduct(productInfo = {}, addressId = '') {
        return new Promise((resolve, reject) => {
            const { itemId, starValue, orderNo, systemItemId, categoryId } = productInfo;
            Commun.post(`${common.starApiPrefix}/order/exchange`, {
                itemId,
                itemNum: 1,
                itemPrice: starValue,
                orderNo,
                categoryId,
                systemItemId,
                addressId,
                starSid: store.getState().exchange.organization
            }).then(res => {
                return resolve(res);
            }).catch(error => {
                return reject(error);
            });
        })
    };

    // 获取用户信息
    getUserInfo() {
        return Commun.get(`${common.userApiPrefix}/address`);
    };
    // 获取StudetCode
    getStudentCode() {
        return Commun.get(`${common.userApiPrefix}/u2/token`);
    }


    /**
     * 展示收货地址弹窗(PC端)或页面(移动端)
     * @param {boolean} bol true:已填地址 false:未填地址
     * @param {Object} item 当前兑换元素
     */
    _showAddress(bol, item = {}) {
        if (common.isMobileShell()) {
            history.push({
                pathname: '/address',
                search: common.withMobileShellSearch(
                    bol ? window.location.search : window.location.search + '&curItem=' + JSON.stringify(item)
                ),
            });
        } else {
            // PC端
            store.dispatch(changeAddressModalVisible(true));
        }
        if (!bol) {
          store.dispatch(saveProcessExchangeCurItem(item));  //存储当前实物兑换的物品信息item
        } else {
          store.dispatch(saveProcessExchangeCurItem({}));
        }
    };

    // 关闭确认地址弹窗
    _closeConfirmAddressModal = () => {
        if (this.#confirmAddressModal && typeof this.#confirmAddressModal.destroy === 'function') {
            this.#confirmAddressModal.destroy();
            this.#confirmAddressModal = null;
        }
    };
    /**
     * 点击兑换按钮
     * @param productIds {Array} 需要兑换的商品id列表
     * @param onSuccess  {Function || null} 兑换成功后的回调
     * @param onError  {Function || null} 兑换失败后的回调
     * @param onComplete  {Function || null} 接口请求完成后的回调
     */
    // 兑换
    onExchange = async ({ productIds = [], onSuccess = this.onExchangeSuccess, onError = null, onComplete = null, studentInfo = null, u2at } = {}) => {
        if (this.#isExchanging) return;
        const { relatedCode, appId, mainOrgId, roleId} = studentInfo
        try {
            const res = await this.getProductInfo(productIds); // 获取商品最新信息
            for (let item of res) {
                const { starValue, itemName, validTerm, categoryId } = item;
                let content = '';
                if (categoryId === categoryMap['gift']) {
                    // 实物奖励兑换确认文案
                    content = intl.get('EXCHANGE_CONFIRM', {
                        starValue,
                        itemName
                    })
                } else {
                    // 虚拟奖励兑换确认文案(区分永久使用权和非永久使用权）
                    content = common.isPermanent(validTerm) ? intl.get('EXCHANGE_CONFIRM_PERMANENT', {
                        starValue,
                        itemName
                    }) : intl.get('EXCHANGE_CONFIRM_DAYS', {
                        starValue,
                        itemName,
                        validTerm
                    });
                }
                Modal.confirm({
                    content,
                    // 弹窗点击确定
                    onOk: async () => {
                        if (this.#isExchanging) return Promise.reject();

                        this.#isExchanging = true;

                        let addressInfo = {consignee: '', phone: '', address: ''};
                        // 实物兑换：在这里先判断是否填地址了，未填写地址，先去填写地址，再兑换成功
                        if (item.categoryId === categoryMap['gift']) {
                            if (isAddressSdkUser(mainOrgId, roleId)) {
                                this.toAddressSdk({ item, relatedCode, appId, mainOrgId, u2at });
                            } else {
                                let response = await this.getUserInfo();
                                const { consignee, phone, address } = response[response.length - 1] || {};
                                if (!consignee || !phone || !address) {
                                    //   用户信息未填写
                                    Modal.info({
                                        // title: intl.get('EXCHANGE_SUCCESS'),
                                        content: intl.get('EMPTY_ADDRESS_TIPS'),
                                        okText: intl.get('FILL_IN'),
                                        onOk: () => {
                                            this._showAddress(false, item);
                                        }
                                    })
                                    this.#isExchanging = false;
                                    return;
                                }
                                addressInfo = { consignee, phone, address };
                                // 去下单兑换
                                store.dispatch(saveProcessExchangeCurItem(item));
                                typeof onSuccess === 'function' && onSuccess(item, '', addressInfo); // 兑换成功的回调
                                this.#isExchanging = false;

                            }
                            store.dispatch(saveProcessExchangeCurItem({}));
                            return;
                        }
                        store.dispatch(saveProcessExchangeCurItem({}));
                        // 创建订单
                        try {
                            const orderNo = await this.createOrder(); // 生成订单号
                            // 兑换商品
                            let res = await this.exchangeProduct({ ...item, orderNo });
                            typeof onSuccess === 'function' && onSuccess(item, res, addressInfo); // 兑换成功的回调
                        } catch(error) {
                            typeof onError === 'function' && onError(item); // 兑换失败的回调
                        }
                        typeof onComplete === 'function' && onComplete(); // 接口请求完成后的回调
                        
                        this.#isExchanging = false;
                    }
                });
            }
        } catch(error) {
            typeof onError === 'function' && onError(); // 兑换失败的回调
        }
    };

    /**
     * 兑换成功后的回调
     * @param productInfo {Object} 商品信息
     */
    onExchangeSuccess = (productInfo = {}, res = '', address) => {
        eventBus.emit('updateStarCount'); // 更新星星数
        switch(productInfo.categoryId) {
            case categoryMap['gift']:

                // 用户信息已填写
                this.#confirmAddressModal = Modal.confirm({
                  // title: intl.get('EXCHANGE_SUCCESS'),  // 去掉 兑换成功 的title提示
                  content: `${intl.get('GIFT_ADDRESS_INFO')}“${address?.consignee}  ${address?.phone}  ${address?.address}”`,
                  cancelText: intl.get('CHANGE_INFO'),
                  onCancel: () => {
                    // 变更信息
                    if (this.#isExchanging) return Promise.reject();
                      this._showAddress(false, productInfo);
                      if (!common.isMobileShell()) return Promise.reject();
                  },
                  okText: intl.get('CONFIRM_MAIL'),
                  // 有地址的情况下 点击 确认邮寄 开始创建订单下单操作
                  onOk: async () => {
                    // 创建订单
                    // 确认邮寄
                    if (this.#isExchanging) return Promise.reject();
                    this.#isExchanging = true;
                    try {
                      const orderNo = await this.createOrder(); // 生成订单号
                      await this.exchangeProduct({ ...productInfo, orderNo });
                      eventBus.emit('updateStarCount'); // 更新星星数
                      Modal.info({
                        title: intl.get('EXCHANGE_SUCCESS'),
                        content: intl.get('MAIL_TIPS'),
                        okText: intl.get('RIGHT_TEXT')
                      });
                      this.#isExchanging = false;
                    } catch(error) {
                      console.error(error);
                      this.#isExchanging = false;
                    }
                  }
                });
                break;
            case categoryMap['avatar']:
            case categoryMap['subtitles']:
            case categoryMap['video']:
            default:
                // dressed 0-未佩戴 1-已佩戴
                if (res && res.dressed && res.dressed === 1) {
                    Modal.info({
                        content: intl.get('EXCHANGE_SUCCESS')
                    });
                    return;
                }
                Modal.confirm({
                    content: intl.get('EXCHANGED_SUCCESS_DRESS'),
                    cancelText: intl.get('SAY_BYE'),
                    okText: intl.get('DRESS'),
                    onOk: () => {
                        onDress(productInfo, false, productInfo.categoryId)
                    }
                });
                break;
        }
    }
    /**
    * 地址
    * @param 
    */
   toAddressSdk = async (content) => {
       openAddressSdk({
           mainOrgId: content.mainOrgId,
           appId: content.appId,
           relatedCode: content.relatedCode,
           item: content.item,
           scene: 'exchange',
           isTest: common.isTest(),
           u2at: content.u2at,
           onClose: () => {
               this.#isExchanging = false;
           },
           onSuccess: (res) => {
               this.#isExchanging = false;
               this.onAddressCompleted(content.item, res.id);
           },
           onError: (err) => {
               this.#isExchanging = false;
               console.log('error', err);
               toast('地址初始化错误');
           }
       });
   }
    /**
     * 地址选择成功回调
     * @param 
     */
    onAddressCompleted = async (productInfo = {}, addressId) => {
        if (this.#isExchanging) return Promise.reject();
        this.#isExchanging = true;
        try {
            const orderNo = await this.createOrder(); // 生成订单号
            await this.exchangeProduct({ ...productInfo, orderNo }, addressId);
            eventBus.emit('updateStarCount'); // 更新星星数
            Modal.info({
                title: intl.get('EXCHANGE_SUCCESS'),
                content: intl.get('MAIL_TIPS'),
                okText: intl.get('RIGHT_TEXT'),
            });
            this.#isExchanging = false;
        } catch (error) {
            console.error(error);
            this.#isExchanging = false;
        }
    }

}

export default new Exchange();


